import { api } from '@/lib/api';
import type { SessionRole } from '@/lib/session-store';

export type OtpPurpose = 'VENDOR_REGISTRATION' | 'USER_REGISTRATION';

export type SendOtpResponse = {
  phone: string;
  purpose: OtpPurpose;
  expires_in_seconds: number;
  cooldown_seconds: number;
  debug_otp_code?: string;
};

export type VerifyOtpResponse = {
  verified: true;
  phone: string;
  purpose: OtpPurpose;
  onboarding_token: string;
};

/** Role → API path prefix + OTP purpose. */
const ROLE_CONFIG: Record<SessionRole, { base: string; purpose: OtpPurpose }> = {
  vendor: { base: '/vendor/auth/otp', purpose: 'VENDOR_REGISTRATION' },
  user: { base: '/user/auth/otp', purpose: 'USER_REGISTRATION' },
};

export async function send_otp(role: SessionRole, phone: string): Promise<SendOtpResponse> {
  const { base, purpose } = ROLE_CONFIG[role];
  const res = await api.post<SendOtpResponse>(`${base}/send`, { phone, purpose });
  return res.data;
}

export async function verify_otp(
  role: SessionRole,
  phone: string,
  code: string,
): Promise<VerifyOtpResponse> {
  const { base, purpose } = ROLE_CONFIG[role];
  const res = await api.post<VerifyOtpResponse>(`${base}/verify`, { phone, purpose, code });
  return res.data;
}

// ---- Back-compat thin wrappers (existing vendor login page imports these) ----
export const send_vendor_otp = (input: { phone: string }) => send_otp('vendor', input.phone);
export const verify_vendor_otp = (input: { phone: string; code: string }) =>
  verify_otp('vendor', input.phone, input.code);
